export default [
  {
    header: 'services.mainVerticalMenu.services',
    resource: ['service', 'serviceCategory'],
    action: 'read',
  },
  {
    title: 'serviceCategories.mainVerticalMenu.serviceCategories',
    icon: 'ListIcon',
    resource: 'serviceCategory',
    action: 'read',
    children: [
      {
        title: 'serviceCategories.mainVerticalMenu.serviceCategoriesList',
        route: 'pages-services-categories-list',
        resource: 'serviceCategory',
        action: 'read',
      },
      {
        title: 'serviceCategories.mainVerticalMenu.serviceCategoryAdd',
        route: 'pages-services-categories-add',
        resource: 'serviceCategory',
        action: 'create',
      },
    ],
  },
  {
    title: 'services.mainVerticalMenu.services',
    icon: 'FileTextIcon',
    resource: 'service',
    action: 'read',
    children: [
      {
        title: 'services.mainVerticalMenu.servicesList',
        route: 'pages-services-list',
        resource: 'service',
        action: 'read',
      },
      {
        title: 'services.mainVerticalMenu.serviceAdd',
        route: 'pages-services-add',
        resource: 'service',
        action: 'create',
      },
    ],
  },
]
